/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `personal_finance` - Życie
 * * `business_finance` - Firma
 * * `iot_gec` - IoT/GEC
 * * `ranking` - Ranking
 */
export type ActivationModuleEnum = typeof ActivationModuleEnum[keyof typeof ActivationModuleEnum];


export const ActivationModuleEnum = {
  personal_finance: 'personal_finance',
  business_finance: 'business_finance',
  iot_gec: 'iot_gec',
  ranking: 'ranking',
} as const;
